import { connect } from "react-redux";

import { FragmentLayout } from "../../core/components/FragmentLayout";
import initialState from "../../core/reducers/initialState";
import UrlUtil from "../../core/util/UrlUtil";
import PageConfig from "../page/PageConfig";
import * as fragments from "./fragments";
import PageInfoConfig from "./PageInfoConfig";

interface IPageInfoLayoutProps {
	config: PageInfoConfig;
	pageInstance: string;
	pageConfig: PageConfig;
}

const PageInfoLayout: React.SFC<IPageInfoLayoutProps> = (props) => (
	<FragmentLayout layout={props.config.mainLayout} fragments={fragments} props={props} />
);

const mapStateToProps = (state: typeof initialState, ownProps) => {
	const currentPage = UrlUtil.getActivePageInstance(state);

	return {
		pageInstance: currentPage,
		pageConfig: state.config.panels[currentPage]
	};
};

export default connect(mapStateToProps)(PageInfoLayout);



// WEBPACK FOOTER //
// ./src/panels/pageInfo/PageInfoPanelLayout.tsx